import { deserialize } from 'class-transformer';
import { FormatSelect } from './FormatSelect';

export const dataTransformer = (data: any) => {
	let xd = deserialize(FormatSelect, JSON.stringify(data));
	return xd;
};
